'use strict';
define([
    'angular',
    'modules/seospider/exam/analysis/report/overview/overview.controller'
],function(angular,SSReportOverviewCtrl){
    var app=angular.module('app.seospider.exam.analysis.report.overview', []);
    app.controller('SSReportOverviewCtrl',SSReportOverviewCtrl);
    return app;
});